import { render, staticRenderFns } from "./FabricTypeCreateEdit.vue?vue&type=template&id=766fc43e&scoped=true&"
import script from "./FabricTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricTypeCreateEdit.vue?vue&type=style&index=0&id=766fc43e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fc43e",
  null
  
)

export default component.exports